@layer app {
.recurring-past-transaction-details-amount-label {
            font-size: var(--font-size-sm);
            font-weight: 600;
            color: var(--label-value-key-text);
    }
} // layer app
